import React, { ReactNode } from "react";
import { theme } from "src/config";
import styled from "styled-components";
import { Icon, IconId, Spacer, Text } from ".";

export interface ITabProps {
  iconId?:   IconId;
  active?:   any;
  toggle?:   boolean;
  title?:    string;
  count?:    ReactNode;
  children?: any;
  className?: string;
  onClick:   () => void;
}

export const Tab = (props: ITabProps ):JSX.Element => {
  const {iconId, title, active, onClick, className, children, count} = props;

  return (

<TabButton active={active} onClick={onClick} className={className}>
  {iconId &&
  <>
  <Icon size="medium" iconId={iconId} color={active ? theme.color.tab.text : theme.color.black}/>
  <Spacer size="xsmall" />
  </>
  }
  {children}
  {title} 
  {count > 0 &&
  <Counter active={active}>{count}</Counter>
  }
</TabButton>
)};

export const Counter = styled.div<{active?: boolean;}>`
  display:         flex;
  justify-content: center;
  height:          2rem;
  min-width:       2.3rem;
  max-width:       fit-content;
  border-radius:   4px;
  margin-left:     0.8rem;
  background:      ${(p) => p.active ? theme.color.tab.background : theme.color.slate5};
  color:           ${theme.color.black};

  :focus {
    background: ${theme.color.tab.background};
  }
`

const TabButton = styled.button<{ active?: boolean}>`
  border-radius:   4px;
  border:          none;
  padding:         1rem 1rem;
  background:      ${(p) => p.active ? theme.color.tab.background : "none"};
  display:         flex;
  font-size:       ${theme.font.size.default};
  justify-content: center;
  align-items:     center;
  flex-direction:  row;
  font-size:       ${theme.font.size.small};
  font-weight:     ${theme.font.weight.normal};
  color:           ${(p) => p.active ? theme.color.tab.text : theme.color.black};
  cursor:          pointer;

  :focus {
    background: ${theme.color.tab.background};
  }

  :hover {
    background: ${theme.color.slate4};
    color: ${(p) => p.active && theme.color.black};

    svg {
      color: ${theme.color.black};
    }

    ${Counter} {
      background: ${theme.color.slate6};
    }
  }
`;

